export const CHAT_AGENT_MESSAGE_TYPE = {
    MESSAGE: 'MESSAGE',
    MESSAGE_END: 'MESSAGE_END',
    MESSAGE_ERROR: 'MESSAGE_ERROR',
};
